<template>
  <div class="text-center">
    <div class="cover-container d-flex h-100 p-3 mx-auto flex-column">
      <main role="main" class="inner cover">
        <div class="mb-5">
          <img src="@/assets/logo.png" class="logo_ma" alt />
        </div>
        <h1 class="cover-heading">{{ $t('System_in_maintenance')}}</h1>
        <p class="lead">Sorry we're down for scheduled maintenace right now!</p>
        <p class="lead mt-5">
          <button @click="$router.push('/')" class="btn btn-md btn-secondary">Go Back</button>
        </p>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  name: "Mainternance"
};
</script>
<style lang="css">
.cover-container {
  max-width: 42em;
  height: 100vh;
  top: 50%;
}
.logo_ma {
  max-width: 250px;
}
.cover {
  padding: 0 1.5rem;
}
.cover .btn-lg {
  padding: 0.75rem 1.25rem;
}
</style>